import { RESERVED_CATEGORY, INPUT_TYPE_CATEGORY } from '../constants/templateLibrary';

/**
 * Helper function that checks if a template category is different than Reserved
 * to return it's inputTypeLabel as a subtitle.
 * @param {Object} {category, inputTypeLabel}
 * @return {?string}
 */
export const getStandardTemplateSubtitle = ({ category, inputTypeLabel, isStock }) =>
    category !== RESERVED_CATEGORY && isStock ? inputTypeLabel : null;

const LABEL_SEPARATOR = '(';

/**
 * @param {Object} template - template coming from getStockTemplates or getCustomTemplatesEntities
 * @return {string} - label to show in question bank
 */
export const getUserFacingTemplateLabel = (template) => {
    const {
        inputTypeLabel,
        data: { label },
    } = template;

    if (label) {
        return label;
    }

    return inputTypeLabel.includes(LABEL_SEPARATOR)
        ? inputTypeLabel.slice(0, inputTypeLabel.indexOf(LABEL_SEPARATOR) - 1)
        : inputTypeLabel;
};

export const getInputTypeTemplateSubtitle = (inputTypeLabel) =>
    inputTypeLabel.includes(LABEL_SEPARATOR) ? inputTypeLabel.slice(inputTypeLabel.indexOf(LABEL_SEPARATOR)) : '';

export const getTemplateSubtitle = (template) => {
    const { data, isStock, category, inputTypeLabel } = template;

    if (!isStock) {
        return data.code;
    }

    return inputTypeLabel && category === INPUT_TYPE_CATEGORY
        ? getInputTypeTemplateSubtitle(inputTypeLabel)
        : getStandardTemplateSubtitle(template);
};
